import {
  Action,
  Container,
  Heading2,
  Icon,
  ImageLite,
  ModalWrapper,
  Paragraph,
  YoutubeVideo,
} from "shared/components";
import { useToggle } from "shared/hooks";
import { parseYouTubeId } from "shared/utils";

import styles from "./Hero036.module.scss";

export const Hero036 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const image = payload?.image ?? {};
  const { videoLink } = payload?.video ?? null;
  const { buttonText } = payload?.video ?? "";

  const videoId = parseYouTubeId(videoLink);

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.content}>
          <Heading2 className={styles.headline} color="dark">
            {headline}
          </Heading2>
          {videoId && (
            <Action onClick={onOpen} className={styles.play}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph color="brand">{buttonText}</Paragraph>
            </Action>
          )}
          {opened && (
            <ModalWrapper onCloseModal={onClose} appearance="full-area">
              <YoutubeVideo id={videoId} />
            </ModalWrapper>
          )}
        </div>
        <ImageLite image={image} className={styles.image} />
      </Container>
    </div>
  );
};

export default Hero036;
